import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Pagination } from 'react-bootstrap';
import './style.css';
import AlertMessage from '../../components/Alert';
import Produto from '../../img/icon/Produto.svg';
import { Title } from "../../components/Title";
import Produto2 from '../../img/icon/Produto2.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Modal } from '@mui/material';
import { FillCrown } from '../../components/Icons';

const CardProduto = ({ id, nome, descricao, quantidadeFuncao, preco, itens, empresaSelecionada, fdtSelecionado, plano, funcoesCadastradas, usuarioId, cupomId }: any) => {
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [showModal, setShowModal] = useState(false);
    const [planoSelecionado, setPlanoSelecionado] = useState(null);
    const navigate = useNavigate();

    const formatarPreco = () => {
        if (preco === 0) return 'Cupom 100%';
        return `R$ ${preco.toFixed(2)}`;
    };

    const handlePaymentCreate = async (id: any) => {
        try {
            if (preco > 0) {
                const product = await handleSearchProduct();
                const response = await api.post('pagamentos/criar', { produto_id: id, id_empresa: empresaSelecionada, id_fdt: fdtSelecionado, change: product, tipo: 'Produto', preco: preco });
                const pagamentoUrl = response.data.url;
                window.location.href = pagamentoUrl;
            } else {
                await processarTransacao();
                navigate('/pgr');
            }
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const inserirPagamento = async () => {
        try {
            const resposta = await api.post('pagamentos/inserir', {
                cupom: true,
                id_mercadopago: 0,
                status: 'A',
                tipo: 'CP',
                tipo_produto: 'Produto',
                total: 0.00
            });
            return resposta.data;
        } catch (erro) {
            console.error('Erro ao inserir pagamento:', erro);
            throw erro;
        }
    };

    const inserirPedido = async (idUsuario: any, idProduto: any, idEmpresa: any, idFdt: any, idPagamento: any) => {
        try {
            const resposta = await api.post('pedidos/inserir', {
                id_usuario: idUsuario,
                id_produto: idProduto,
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_pagamento: idPagamento,
                tipo_produto: 'Produto',
                entregue: true,
                cupom_id: cupomId
            });
            return resposta.data;
        } catch (erro) {
            console.error('Erro ao inserir pedido:', erro);
            throw erro;
        }
    };

    const liberarPlano = async () => {
        try {
            await api.post('liberar-plano');
        } catch (error) {
            console.error("Erro ao vincular plano ao usuário:", error);
            throw error;
        }
    }

    const processarTransacao = async () => {
        try {
            const pagamento = await inserirPagamento();
            const pedido = await inserirPedido(usuarioId, id, empresaSelecionada, fdtSelecionado, pagamento.id);
            await liberarPlano();
            setAlert({ show: true, message: 'Transação processada com sucesso!', variant: 'success' });
        } catch (erro) {
            console.error('Erro ao processar a transação:', erro);
            setAlert({ show: true, message: 'Erro ao processar a transação', variant: 'danger' });
        }
    };

    const handleComprarPlano = (id: any, quantidadeFuncao: number) => {
        if (!empresaSelecionada) {
            setAlert({ show: true, message: 'Por favor, selecione uma empresa antes de comprar o plano.', variant: 'danger' });
            return;
        }

        if (quantidadeFuncao >= funcoesCadastradas) {
            handlePaymentCreate(id);
        } else {
            setPlanoSelecionado(id);
            setShowModal(true);
        }
    };

    const handleShowAlert = () => {
        setAlert({ show: true, message: 'Por favor, selecione uma empresa e uma frente de trabalho antes de comprar o plano.', variant: 'danger' });
    };

    const handleSearchProduct = async () => {
        if (empresaSelecionada !== null && fdtSelecionado !== null) {
            try {
                const productResponse = await api.get(`listar-produto-user/${empresaSelecionada}/${fdtSelecionado}`);
                const productData = productResponse.data;
                const produtos = productData.filter((item: { tipo_produto: string; }) => item.tipo_produto === 'Produto');
                return produtos.length !== 0;
            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        }
    };

    return (
        <>
            {plano === id ? (
                <div className="card-produto-possui">
                    <div className="conteudo-container">
                        <img className="produtoIcon" src={Produto2} alt="Icon Item" />
                        <div className="texto-container">
                            <div className="nome-plano">Plano Individual</div>
                            <div className="tipo-plano" style={{ color: 'rgb(32, 154, 32)' }}>{nome}</div>
                        </div>
                    </div>
                    <p className="descricao">
                        {descricao}
                    </p>
                    <div className="valor" style={{ color: 'rgb(32, 154, 32)' }}>{formatarPreco()}</div>
                    <div className="incluso-titulo" style={{ color: 'rgb(32, 154, 32)' }}>O que está incluso</div>
                    <ul className="lista-itens">
                        <li className="item">
                            <div className="check-icon" style={{ backgroundColor: 'rgb(32, 154, 32)' }}></div>
                            {itens.map((item: { nome: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | React.PromiseLikeOfReactNode | null | undefined; }, index: React.Key | null | undefined) => (
                                <span className="check-texto" key={index}>
                                    {item.nome}
                                    {index !== itens.length - 1 && ',\u00A0'}
                                </span>
                            ))}
                        </li>
                        <li className="item">
                            <div className="check-icon" style={{ backgroundColor: 'rgb(32, 154, 32)' }}></div>
                            <span className="check-texto">{quantidadeFuncao} Funções</span>
                        </li>
                    </ul>
                    <button className="botao-possui">
                        Já Possui
                    </button>
                </div>
            ) : (
                <div className="card-produto">
                    <div className="conteudo-container">
                        <img className="produtoIcon" src={Produto} alt="Icon Item" />
                        <div className="texto-container">
                            <div className="nome-plano">Plano Individual</div>
                            <div className="tipo-plano">{nome}</div>
                        </div>
                    </div>
                    <div className="descricao">
                        {descricao}
                    </div>
                    <div className="valor">{formatarPreco()}</div>
                    <div className="incluso-titulo">O que está incluso</div>
                    <ul className="lista-itens">
                        <li className="item">
                            <div className="check-icon"></div>
                            {itens.map((item: { nome: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | React.PromiseLikeOfReactNode | null | undefined; }, index: React.Key | null | undefined) => (
                                <span className="check-texto" key={index}>
                                    {item.nome}
                                    {index !== itens.length - 1 && ',\u00A0'}
                                </span>
                            ))}
                        </li>
                        <li className="item">
                            <div className="check-icon"></div>
                            <span className="check-texto">{quantidadeFuncao} Funções</span>
                        </li>
                    </ul>
                    {empresaSelecionada && fdtSelecionado ? (
                        <button onClick={() => handleComprarPlano(id, quantidadeFuncao)} className="botao-comprar">
                            {preco === 0 ? 'Continuar' : 'Comprar'}
                        </button>
                    ) : (
                        <button onClick={handleShowAlert} className="botao-comprar">
                            {preco === 0 ? 'Continuar' : 'Comprar'}
                        </button>
                    )}
                </div>
            )}
            <Modal
                open={showModal}
                onClose={() => setShowModal(false)}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px'
                }}>
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>Cuidado!</h2>
                    <p style={{ textAlign: 'center' }}>
                        O plano selecionado permite o cadastro de até {quantidadeFuncao} funções, e você já cadastrou {funcoesCadastradas}.
                        Tem certeza de que deseja comprar este plano?
                    </p>
                    <Row>
                        <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }} onClick={() => handlePaymentCreate(planoSelecionado)}>
                            Sim
                        </Button>
                        <Button variant="contained" color="secondary" style={{ marginTop: '20px', background: 'red', color: '#fff' }} onClick={() => setShowModal(false)}>
                            Voltar
                        </Button>
                    </Row>
                </Box>
            </Modal>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })} />
        </>
    );
};


const CardAdicionais = ({ id, nome, descricao, preco, empresaSelecionada, fdtSelecionado, plano, entregue, tipo, usuarioId, cupomId, quantidadeFuncao }: any) => {
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [showModalVencido, setShowModalVencido] = useState(false);
    const [modalMensagem, setModalMensagem] = useState('');
    const [showModalSubstituicao, setShowModalSubstituicao] = useState(false)
    const [diasRestantes, setDiasRestantes]: any = useState()
    const navigate = useNavigate();

    const formatarPreco = () => {
        if (preco === 0) return 'Cupom 100%';
        return `R$ ${preco.toFixed(2)}`;
    };

    const handleShowAlert = () => {
        setAlert({
            show: true,
            message: 'Por favor, selecione uma empresa e uma frente de trabalho antes de comprar o plano.',
            variant: 'danger'
        });
    };

    const inserirPagamento = async () => {
        try {
            const resposta = await api.post('pagamentos/inserir', {
                cupom: true,
                id_mercadopago: 0,
                status: 'A',
                tipo: 'CP',
                tipo_produto: 'Adicional',
                total: 0.00
            });
            return resposta.data;
        } catch (erro) {
            console.error('Erro ao inserir pagamento:', erro);
            throw erro;
        }
    };

    const inserirPagamentoGlobal = async () => {
        try {
            const resposta = await api.post('pagamentos/inserir', {
                cupom: true,
                id_mercadopago: 0,
                status: 'A',
                tipo: 'CP',
                tipo_produto: 'Global',
                total: 0.00
            });
            return resposta.data;
        } catch (erro) {
            console.error('Erro ao inserir pagamento:', erro);
            throw erro;
        }
    };

    const inserirPedido = async (idUsuario: any, idProduto: any, idEmpresa: any, idFdt: any, idPagamento: any) => {
        try {
            const resposta = await api.post('pedidos/inserir', {
                id_usuario: idUsuario,
                id_produto: idProduto,
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_pagamento: idPagamento,
                tipo_produto: 'Adicional',
                entregue: true,
                cupom_id: cupomId
            });
            return resposta.data;
        } catch (erro) {
            console.error('Erro ao inserir pedido:', erro);
            throw erro;
        }
    };

    const inserirPedidoGlobal = async (idUsuario: any, idProduto: any, idEmpresa: any, idFdt: any, idPagamento: any) => {
        try {
            const resposta = await api.post('pedidos/inserir', {
                id_usuario: idUsuario,
                id_produto: idProduto,
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_pagamento: idPagamento,
                tipo_produto: 'Global',
                entregue: true,
                cupom_id: cupomId
            });
            return resposta.data;
        } catch (erro) {
            console.error('Erro ao inserir pedido:', erro);
            throw erro;
        }
    };

    const inserirRevisaoGlobal = async (idUsuario: any, idEmpresa: any, idFdt: any) => {
        try {
            const resposta = await api.post('inserir-revisao-global', {
                idUsuario: idUsuario,
                idEmpresa: idEmpresa,
                idFdt: idFdt
            });
            return resposta.data;
        } catch (error) {
            console.error('Erro ao inserir global:', error);
            throw error;
        }
    }

    const inserirRevisaoAdicional = async (idUsuario: any, idEmpresa: any, idFdt: any) => {
        try {
            const resposta = await api.post('inserir-revisao-adicional', {
                idUsuario: idUsuario,
                idEmpresa: idEmpresa,
                idFdt: idFdt
            });
            return resposta.data;
        } catch (error) {
            console.error('Erro ao inserir revisão adicional:', error);
            throw error;
        }
    }

    

    const processarTransacao = async () => {
        try {
            const pagamento = await inserirPagamento();
            const pedido = await inserirPedido(usuarioId, id, empresaSelecionada, fdtSelecionado, pagamento.id);
            const adicional = await inserirRevisaoAdicional(usuarioId, empresaSelecionada, fdtSelecionado)
            setAlert({ show: true, message: 'Transação processada com sucesso!', variant: 'success' });
        } catch (erro) {
            console.error('Erro ao processar a transação:', erro);
            setAlert({ show: true, message: 'Erro ao processar a transação', variant: 'danger' });
        }
    };

    const processarTransacaoGlobal = async () => {
        try {
            const pagamento = await inserirPagamentoGlobal();
            const pedido = await inserirPedidoGlobal(usuarioId, id, empresaSelecionada, fdtSelecionado, pagamento.id);
            const global = await inserirRevisaoGlobal(usuarioId, empresaSelecionada, fdtSelecionado)
            setAlert({ show: true, message: 'Transação processada com sucesso!', variant: 'success' });
        } catch (error) {
            console.error('Erro ao processar a transação:', error);
            setAlert({ show: true, message: 'Erro ao processar a transação', variant: 'danger' });
        }
    }

    async function fetchUltimaEmissaoVencida(
        idEmpresa: any,
        idFdt: any
    ): Promise<{ status: 'expired' | 'expiring' | false; diasRestantes?: number }> {
        try {
            const response = await api.post('listar-pgr', {
                id_empresa: idEmpresa,
                id_fdt: idFdt,
            });

            const emissaoData = response.data.emissoes || [];

            if (emissaoData.length > 0) {
                const ultimaEmissao = emissaoData[emissaoData.length - 1];

                if (ultimaEmissao.expires_at) {
                    const dataAtual = new Date();
                    const dataExpiracao = new Date(ultimaEmissao.expires_at);

                    if (dataAtual > dataExpiracao) {
                        return { status: 'expired' };
                    }

                    const diffTime = dataExpiracao.getTime() - dataAtual.getTime();
                    const diffDays = Math.ceil(diffTime / (1000 * 3600 * 24));

                    if (diffDays <= 30) {
                        return { status: 'expiring', diasRestantes: diffDays };
                    }
                }
            }

            return { status: false };
        } catch (error) {
            console.error('Erro ao verificar emissão:', error);
            return { status: false };
        }
    }

    const handlePaymentCreate = async (id: any) => {
        if (!empresaSelecionada) {
            setAlert({
                show: true,
                message: 'Por favor, selecione uma empresa antes de comprar o plano.',
                variant: 'danger',
            });
            return;
        }

        const hasMainProduct = await handleSearchProduct();
        if (!hasMainProduct) {
            setAlert({
                show: true,
                message: 'Para adquirir esse plano, você precisa ter comprado um plano principal!',
                variant: 'danger',
            });
            return;
        }

        const isEmissaoVencida = await fetchUltimaEmissaoVencida(empresaSelecionada, fdtSelecionado);

        if (tipo === 'Adicional') {
            if (isEmissaoVencida.status === 'expired') {
                setModalMensagem('A última emissão está vencida. É necessária a aquisição de uma nova revisão anual global.');
                setShowModalVencido(true);
                return;
            } else if (isEmissaoVencida.status === 'expiring') {
                setModalMensagem(`Faltam ${isEmissaoVencida.diasRestantes} dias para a sua emissão expirar. Considere adquirir uma nova revisão anual global.`);
                setShowModalVencido(true);
                return;
            }
        }

        if (tipo === 'Global') {
            if (isEmissaoVencida.status === false) {
                setModalMensagem('Falta mais de um mês para a última emissão expirar. Ao continuar, a data de vigência da nova revisão iniciará a partir da data atual.');
                setShowModalSubstituicao(true);
                return;
            }
        }

        const checkFunctionsPlano = await fetchFuncoesUltimaEmissao(empresaSelecionada, fdtSelecionado)
        if (checkFunctionsPlano) {
            if (quantidadeFuncao < checkFunctionsPlano) {
                setAlert({ show: true, message: 'Não é possível comprar uma revisão com menos funções que seu plano atual!', variant: 'danger' });
                return;
            }
        }
        

        try {
            if (preco > 0) {
                const response = await api.post('pagamentos/criar', {
                    produto_id: id,
                    id_empresa: empresaSelecionada,
                    id_fdt: fdtSelecionado,
                    change: plano == id,
                    tipo,
                    preco
                });

                const pagamentoUrl = response.data.url;
                window.location.href = pagamentoUrl;
            } else {
                if (tipo === 'Global') {
                    await processarTransacaoGlobal();
                } else {
                    await processarTransacao();
                }
                navigate('/pgr');

            }

        } catch (error) {
            console.error('Error fetching employees:', error);
        }
    };


    const handleSearchProduct = async () => {
        if (empresaSelecionada !== null && fdtSelecionado !== null) {
            try {
                const productResponse = await api.get(`listar-produto-user/${empresaSelecionada}/${fdtSelecionado}`);
                const productData = productResponse.data;

                if (productData.length > 0) {
                    const produtos = productData.filter((item: { tipo_produto: string }) => item.tipo_produto === 'Produto');
                    return produtos.length !== 0;
                } else {
                    return false;
                }
            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        }
    };

    const fetchFuncoesUltimaEmissao = async (empresaSelecionada: any, fdtSelecionado: any) => {
        try {
            const response = await api.get(`listar-produtos-funcoes/${empresaSelecionada}/${fdtSelecionado}`)
            const responseData = response.data;

            if (responseData) {
                return Number(responseData.quantidade)
            } else {
                return 0;
            }

        } catch(error) {
            console.error("Error fetching functions:", error);
        }
    }

    const handlePurchaseAdditionalRevision = async (idProduto: number) => {
        try {
            if (preco > 0) {
                const response = await api.post('pagamentos/criar', {
                    produto_id: idProduto,
                    id_empresa: empresaSelecionada,
                    id_fdt: fdtSelecionado,
                    change: false,
                    tipo: 'Adicional',
                    preco
                });

                const pagamentoUrl = response.data.url;
                window.location.href = pagamentoUrl;
            } else {
                await processarTransacao();
                navigate('/pgr');
            }

        } catch (error) {
            console.error('Erro ao realizar a compra da revisão adicional:', error);
        }
    };

    const handlePurchaseGlobalRevision = async (idProduto: number) => {
        try {
            if (preco > 0) {
                const response = await api.post('pagamentos/criar', {
                    produto_id: idProduto,
                    id_empresa: empresaSelecionada,
                    id_fdt: fdtSelecionado,
                    change: false,
                    tipo: 'Global',
                    preco
                });

                const pagamentoUrl = response.data.url;
                window.location.href = pagamentoUrl;
            } else {
                await processarTransacaoGlobal();
                navigate('/pgr');
            }

        } catch (error) {
            console.error('Erro ao realizar a compra da revisão global:', error);
        }
    };

    return (
        <>
            {plano === id && entregue === 1 ? (
                <div className="card-adicional-possui">
                    <div className="conteudo-container">
                        <img className="produtoIcon" src={Produto2} alt="Icon Item" />
                        <div className="texto-container">
                            <div className="nome-plano">Adicional</div>
                            <div className="tipo-plano" style={{ color: 'rgb(32, 154, 32)' }}>{nome}</div>
                        </div>
                    </div>
                    <p className="descricao">
                        {descricao}
                    </p>
                    <div className="valor" style={{ color: 'rgb(32, 154, 32)' }}>{formatarPreco()}</div>
                    <div className="incluso-titulo" style={{ color: 'rgb(32, 154, 32)' }}>O que está incluso</div>
                    <ul className="lista-itens">
                        <li className="item">
                            <div className="check-icon" style={{ backgroundColor: 'rgb(32, 154, 32)' }}></div>
                            <span className="check-texto">{tipo === 'Global' ? 'Revisão Anual Global Inclusa' : 'Nova Revisão'}</span>
                        </li>
                    </ul>
                    <button className="botao-possui">
                        Já Possui
                    </button>
                </div>
            ) : (
                <div className="card-adicional">
                    <div className="conteudo-container">
                        <img className="produtoIcon" src={Produto} alt="Icon Item" />
                        <div className="texto-container">
                            <div className="nome-plano">Adicional</div>
                            <div className="tipo-plano">{nome}</div>
                        </div>
                    </div>
                    <p className="descricao">
                        {descricao}
                    </p>
                    <div className="valor">{formatarPreco()}</div>
                    <div className="incluso-titulo">O que está incluso</div>
                    <ul className="lista-itens">
                        <li className="item">
                            <div className="check-icon"></div>
                            <span className="check-texto">{tipo === 'Adicional' ? 'Nova Revisão' : 'Revisão Global'}</span>
                        </li>
                        <li className="item">
                            <div className="check-icon"></div>
                            <span className="check-texto">{quantidadeFuncao} Funções</span>
                        </li>
                    </ul>
                    {empresaSelecionada && fdtSelecionado ? (
                        <button onClick={() => handlePaymentCreate(id)} className="botao-comprar">
                            {preco === 0 ? 'Continuar' : 'Comprar'}
                        </button>
                    ) : (
                        <button onClick={handleShowAlert} className="botao-comprar">
                            {preco === 0 ? 'Continuar' : 'Comprar'}
                        </button>
                    )}
                </div>
            )}

            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
            <Modal
                open={showModalVencido}
                onClose={() => setShowModalVencido(false)}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '600px',
                    maxWidth: '90%',
                }}>
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>
                        {modalMensagem.includes('expirar') ? 'Emissão atual prestes a expirar' : 'Emissão atual vencida'}
                    </h2>
                    <p style={{ textAlign: 'center', fontSize: '16px', marginBottom: '20px' }}>{modalMensagem}</p>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }}
                        onClick={() => setShowModalVencido(false)}
                    >
                        Fechar
                    </Button>
                    {modalMensagem.includes('expirar') && (
                        <Button
                            variant="outlined"
                            color="secondary"
                            style={{ marginTop: '15px', borderColor: '#0d6efd', color: '#0d6efd' }}
                            onClick={() => handlePurchaseAdditionalRevision(id)}
                        >
                            Comprar Revisão Adicional
                        </Button>
                    )}

                </Box>
            </Modal>
            <Modal
                open={showModalSubstituicao}
                onClose={() => setShowModalSubstituicao(false)}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '600px',
                    maxWidth: '90%',
                }}>
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>
                        Revisão Anual Global
                    </h2>
                    <p style={{ textAlign: 'center', fontSize: '16px', marginBottom: '20px' }}>
                        {modalMensagem}
                    </p>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{
                            marginTop: '15px',
                            padding: '10px 30px',
                            fontSize: '16px',
                            background: '#0d6efd',
                            color: '#fff',
                        }}
                        onClick={() => handlePurchaseGlobalRevision(id)}
                    >
                        Comprar Revisão Anual Global
                    </Button>
                    <Button
                        variant="outlined"
                        color="secondary"
                        style={{
                            marginTop: '20px',
                            color: '#0d6efd',
                            padding: '8px 20px',
                            borderColor: '#0d6efd',
                            fontSize: '12px'
                        }}
                        onClick={() => setShowModalSubstituicao(false)}
                    >
                        Fechar
                    </Button>

                </Box>
            </Modal>
        </>
    );
};

export function SelecionarPlanos() {
    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [companies, setCompanies] = useState([]);
    const [fdts, setFdts] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedFdt, setSelectedFdt] = useState(null);
    const [paramCompany, setParamCompany] = useState(0);
    const [entregue, setEntregue] = useState(0);
    const [paramFdt, setParamFdt] = useState(0);
    const [paramRevisao, setParamRevisao] = useState(0);
    const [products, setProducts] = useState<any>([]);
    const [additionals, setAdditionals] = useState([]);
    const [planoProduto, setPlanoProduto] = useState(null);
    const [funcoesCadastradas, setFuncoesCadastradas] = useState(null);
    const [planoAdicional, setPlanoAdicional] = useState(null);
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [cupom, setCupom]: any = useState(null);
    const [preco, setPreco] = useState<number>();
    const [descontoTotal, setDescontoTotal] = useState(false);
    const [cupomId, setCupomId] = useState();
    const [nivelAcesso, setNivelAcesso] = useState();
    const [usuarioId, setUsuarioId] = useState();
    const [cuponsAtivos, setCuponsAtivos] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            const response = await api.get('nivel-acesso');
            setNivelAcesso(response.data.nivel);
            const userData = await api.get('dados-usuario');
            setUsuarioId(userData.data.id);
            const cupons = await api.get('listar-cupons');
            if (Array.isArray(cupons.data) && cupons.data.length > 0) {
                const cuponsAtivos = cupons.data.filter((cupom: any) => !cupom.desativado);
                if (cuponsAtivos.length > 0) setCuponsAtivos(true);
            }
        }
        loadCompanies();
        setPlanoProduto(null);
        setPlanoAdicional(null);
        setIsPageLoaded(true);
        fetchData();
    }, []);

    useEffect(() => {
        searchPlanoComprado()
    }, [selectedCompany, selectedFdt])

    useEffect(() => {
        loadProducts();
        loadFdts(selectedCompany);
    }, [selectedCompany]);

    useEffect(() => {
        if (selectedCompany) {
            loadFdts(selectedCompany);
            if (selectedFdt !== null) {
                handleSearchProduct();
                loadFunctions();
                verificaAplicacaoCupom();
            }
        }
    }, [selectedCompany, selectedFdt]);

    useEffect(() => {
        if (paramCompany && paramFdt && paramRevisao) {
            loadFunctions();
        }
    }, [paramFdt, paramCompany, paramRevisao]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const empresaId = searchParams.get('empresa');
        const idFdt = searchParams.get('fdt');
        const idRevisao = searchParams.get('revisao');

        if (empresaId) setParamCompany(Number.parseInt(empresaId));
        if (idFdt) setParamFdt(Number.parseInt(idFdt));
        if (idRevisao) setParamRevisao(Number.parseInt(idRevisao));
    }, [location]);


    const loadProducts = async () => {
        try {
            const response = await api.get('produtos');
            const allProducts = response.data;
            const produtosFiltrados = allProducts.filter((item: { tipo: string; }) => item.tipo === 'Produto');
            const adicionaisFiltrados = allProducts.filter((item: { tipo: string; }) => item.tipo === 'Adicional' || item.tipo === 'Global');
            setProducts(produtosFiltrados);
            setAdditionals(adicionaisFiltrados);
            console.log(additionals)
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas');
            setCompanies(response.data.message ? [] : response.data);
            setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const loadFdts = async (companyId: null) => {
        try {
            const response = await api.post(`listar-fdts-por-empresa/${companyId}`);
            setFdts(response.data);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const loadFunctions = async () => {
        try {
            const payload = {
                id_fdt: paramFdt,
                id_empresa: paramCompany,
                id_revisao: paramRevisao
            }
            const response = await api.post('listar-funcoes-usuario', payload);
            if (response.data) {
                setFuncoesCadastradas(response.data.length);
            } else {
                console.error("Unexpected response format:", response.data);
            }
        } catch (error) {
            console.error("Error fetching functions:", error);
        }
    };

    const verificaAplicacaoCupom = async () => {
        try {
            const cupomAplicado = await api.get(`verificar-aplicacao-cupom/${selectedCompany}/${selectedFdt}/${usuarioId}`);
            if (cupomAplicado.status === 200 && products.length > 0) {
                for (const prod of products) {
                    const produtoComCupom = cupomAplicado.data.find((item: any) => item.id === prod.id);
                    if (produtoComCupom) prod.preco = produtoComCupom.preco;
                }
                setProducts([...products]);
            }
        } catch (error) {
            console.error("Erro ao verificar aplicacao do cupom: ", error);
        }
    }


    const searchPlanoComprado = async () => {
        try {
            const response = await api.get('buscar-compra-usuario');

            if (response.data == true && isPageLoaded) {
                setShowAccessModal(true);
            }

        } catch (error) {
            console.log(error);
        }
    };

    const handleSelectCompany = (id: React.SetStateAction<null>) => {
        setSelectedCompany(id);
    };

    const handleSelectFdt = (id: React.SetStateAction<null>) => {
        setSelectedFdt(id);
    };

    const handleCloseAccessModal = async () => {
        setShowAccessModal(false);
        await api.post('atualizar-plano-comprado')
    };

    const handleAtualizarPlanoComprado = async () => {
        await api.post('atualizar-plano-comprado')
    }

    const handleSearchProduct = async () => {
        if (selectedFdt !== null && selectedCompany !== null) {
            try {
                const productResponse = await api.get(`listar-produto-user/${selectedCompany}/${selectedFdt}`);
                const productData = productResponse.data;
                const produtos = productData.filter((item: { tipo_produto: string; }) => item.tipo_produto === 'Produto');
                const adicionais = productData.filter((item: { tipo_produto: string; }) => item.tipo_produto === 'Adicional' || item.tipo_produto === 'Global');
                if (productData.length !== 0) {
                    setPlanoProduto(produtos[0].id_produto);
                    setPlanoAdicional(adicionais[0].id_produto);
                    setEntregue(adicionais[0].entregue);
                } else {
                    setPlanoProduto(null);
                    setPlanoAdicional(null);
                }
            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        }
    };

    const handleSearchCupom = async () => {
        try {
            const response = await api.post(`buscar-cupom-por-nome/${cupom.toUpperCase()}`);
            
            if (response.status === 200 && response.data?.cupom?.desconto) {
                const { desconto, id: cupomId, produtos: produtosDoCupom } = response.data.cupom;
                setCupomId(cupomId);
                const produtosComDesconto: any[] = [];
    
                if (products) {
                    products.forEach((produto: any) => {
                        const aplicarDesconto = produtosDoCupom.some((p: any) => p.id === produto.id);
    
                        if (aplicarDesconto) {
                            const novoPreco = calcularNovoPreco(produto.preco, desconto);
                            if (novoPreco === 0) {
                                setDescontoTotal(true);
                                produto.preco = 0;
                            } else {
                                produto.preco = novoPreco;
                            }
                            produtosComDesconto.push(produto.nome); 
                        }
                    });
                }
    
                if (additionals) {
                    additionals.forEach((adicional: any) => {
                        const aplicarDesconto = produtosDoCupom.some((p: any) => p.id === adicional.id);
    
                        if (aplicarDesconto) {
                            const novoPreco = calcularNovoPreco(adicional.preco, desconto);
                            if (novoPreco === 0) {
                                setDescontoTotal(true);
                                adicional.preco = 0;
                            } else {
                                adicional.preco = novoPreco;
                            }
                            produtosComDesconto.push(adicional.nome); 
                        }
                    });
                }
    
                await api.post(`cupons/desativar/${cupomId}`);
    
                const mensagemSucesso = `Cupom aplicado com sucesso! Desconto em: ${produtosComDesconto.join(', ')}`;
                setAlert({ show: true, message: mensagemSucesso, variant: 'success' });
            } else {
                mostrarAlertaDeErro(response.data?.message || 'Cupom inválido ou expirado.');
            }
        } catch (error: any) {
            const errorMessage = error.response?.data?.message || 'Erro ao buscar o cupom.';
            mostrarAlertaDeErro(errorMessage);
            console.log(error);
        }
    };

    const calcularNovoPreco = (preco: number, desconto: number): number => {
        const novoPreco = (preco * (1 - desconto / 100));
        return novoPreco < 0 ? 0 : novoPreco;
    };

    const mostrarAlertaDeErro = (mensagem: string) => {
        setAlert({ show: true, message: mensagem, variant: 'danger' });
    };


    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                {companies.length !== 0 ? (
                    <>
                        <CardContent>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Col md={2} style={{ width: '50%', position: 'relative', zIndex: 2 }}>
                                    <Text text="Empresa" />
                                    <Select width="600px" id='empresas' onSelect={handleSelectCompany}>
                                        {companies.map((company: any, index) => (
                                            <Options
                                                key={company.id}
                                                value={company.id}
                                                name={company.nome}
                                                selected={paramCompany !== 0 ? company.id === paramCompany : index === 0}
                                            />
                                        ))}
                                    </Select>
                                </Col>
                            </div>
                            {selectedCompany && (
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px' }}>
                                    <Col md={2} style={{ width: '50%', position: 'relative', zIndex: 1 }}>
                                        <Text text="Frente de Trabalho" />
                                        <Select width="600px" id='fdts' onSelect={handleSelectFdt}>
                                            {fdts.map((fdt: any, index) => (
                                                <Options key={fdt.id} value={fdt.id} name={fdt.nome} selected={paramFdt !== 0 && fdt.id === paramFdt} />
                                            ))}
                                        </Select>
                                    </Col>
                                </div>
                            )}
                        </CardContent>
                    </>
                ) : null}
                <CardContent>
                    {selectedCompany && selectedFdt ? (
                        <div className="content-wrapper">
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <h1 className="card-header">Planos</h1>
                                <p className="card-paragraph">
                                    Adquira o plano perfeito que se alinha aos seus desejos e necessidades. A sua seleção determinará o leque de benefícios exclusivos aos quais terá acesso.
                                </p>
                            </div>
                            <div className="produtos-container">
                                {products.map((produto: any) => (
                                    produto.desativado !== 1 && (
                                        <CardProduto
                                            key={produto.id}
                                            id={produto.id}
                                            quantidadeFuncao={produto.quantidade}
                                            descricao={produto.descricao}
                                            nome={produto.nome}
                                            itens={produto.produtos_itens}
                                            preco={produto.preco}
                                            empresaSelecionada={selectedCompany}
                                            fdtSelecionado={selectedFdt}
                                            plano={planoProduto}
                                            funcoesCadastradas={funcoesCadastradas}
                                            usuarioId={usuarioId}
                                            cupomId={cupomId}
                                        />
                                    )
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="content-wrapper">
                            <h1 className="card-header">Cadastre uma Empresa</h1>
                            <p className="card-paragraph">
                                Para acessar os planos disponíveis, é necessário primeiro cadastrar sua empresa. Para fazer isso, basta clicar no link a seguir:
                            </p>
                            <p><a href='/empresas'>Cadastrar</a></p>
                        </div>
                    )}
                </CardContent>
                {selectedCompany && selectedFdt && (
                    <>
                        <CardContent>
                            <div className="content-wrapper">
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <h1 className="card-header">Adicionais</h1>
                                    <p className="card-paragraph">
                                        Adquira um adicional para seu plano que se alinha à suas necessidades.
                                    </p>
                                </div>
                                <div className="produtos-container">
                                    {additionals.map((produto: any) => (
                                        produto.desativado !== 1 && (
                                            <CardAdicionais
                                                key={produto.id}
                                                id={produto.id}
                                                descricao={produto.descricao}
                                                nome={produto.nome}
                                                preco={produto.preco}
                                                empresaSelecionada={selectedCompany}
                                                fdtSelecionado={selectedFdt}
                                                plano={planoAdicional}
                                                entregue={entregue}
                                                tipo={produto.tipo}
                                                usuarioId={usuarioId}
                                                cupomId={cupomId}
                                                quantidadeFuncao={produto.quantidade}
                                            />
                                        )
                                    ))}
                                </div>
                            </div>
                        </CardContent>
                        {cuponsAtivos && (
                            <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                                <h6>Se você possui um cupom de desconto, insira-o aqui para aproveitar o desconto!</h6>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>
                                    <input
                                        type="text"
                                        id="nome"
                                        placeholder="Digite o Código"
                                        value={cupom}
                                        onChange={(e) => setCupom(e.target.value.toUpperCase())}
                                        style={{ width: '145px', height: '50px', border: '1px solid lightgray', borderRadius: '3px', fontSize: '13px', padding: '10px' }}
                                    />
                                    <Button
                                        style={{ backgroundColor: '#02298A', color: 'white', border: 'none', borderRadius: '5px', height: '40px' }}
                                        onClick={handleSearchCupom}>
                                        Aplicar
                                    </Button>
                                </div>
                            </div>
                        )}
                    </>
                )}
                <Modal
                    open={showAccessModal}
                    onClose={handleCloseAccessModal}
                    style={{ backdropFilter: 'blur(10px)' }}
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '40%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '400px'
                    }}>
                        <FillCrown />
                        <h2 style={{ color: '#333', marginBottom: '20px' }}>Plano Adquirido</h2>
                        <p style={{ textAlign: 'center' }}>Obrigado por comprar o plano! Agora, desfrute dos benefícios de sua nova compra!</p>
                        <Row>
                            <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }} onClick={handleAtualizarPlanoComprado} href={`/pgr?empresa=${paramCompany}&fdt=${paramFdt}`}> {/*  Revisão Mockada*/}
                                PGR
                            </Button>
                            <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }} onClick={handleAtualizarPlanoComprado} href={`/pcmso?empresa=${paramCompany}&fdt=${paramFdt}`}> {/*  Revisão Mockada*/}
                                PCMSO
                            </Button>
                        </Row>
                    </Box>
                </Modal>
            </Main>

            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })} />

        </div>
    );
}
